// The invitation a guest opens is one document they read top to bottom, and its
// in-page anchors -- RSVP, back to the top, a jump into the schedule -- are how
// they move around it. Turbo Frames carry the RSVP reply, so Turbo stays; Turbo
// Drive has nowhere to navigate here, and a Drive visit for an in-page anchor
// replaces the whole document, throwing away everything the curated theme
// runtime built and leaving the section the guest asked for blank.
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers/index.js"

Turbo.session.drive = false
